export const URL = {
  PULSEPASSPORT: "https://pulsemarket.com/passport/",
  PRIVACY_POLICY: "https://pulsemarket.com/terms-and-privacy/",
  TERMS_OF_USE: "https://pulsemarket.com/terms-and-privacy/",
  ESG_PASSPORT_ACTION_GUIDE:
    "https://pulsemarket.com/wp-content/uploads/2023/06/ESG-Passport-Report-1.pdf",
};
